import React, { Component } from "react"
import { EventCard } from "../components/EventCard/index"
import { getAllEvents } from "../api/async/events"
import { endEvent } from "../utils/index"

class Events extends Component {
  state = {
    events: []
  }
  componentWillMount = async () => {
    const events = await getAllEvents()
    this.setState({ events: events.data })
    document.title = "Run24Hrs - ของสะสมทั้งหมด"
  }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            marginBottom: "10px"
          }}
        >
          <h1 className="mobile-h1">ของสะสมทั้งหมด</h1>
        </div>
        {this.state.events
          .filter(each => each.is_public)
          .filter(each => each.show_homepage)
          .filter(each => !endEvent(each))
          .map(each => (
            <EventCard event={each} />
          ))}
      </React.Fragment>
    )
  }
}

export default Events



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Events.js